var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "sales-value-contribution" } },
    [
      _c(
        "b-card",
        { staticClass: "responsive-card" },
        [
          _c(
            "b-card-header",
            [
              _c("b-card-title", { staticClass: "text-center" }, [
                _vm._v("Sales Value Contribution by Salesperson"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "chart-container" },
            [
              _c("apexchart", {
                attrs: {
                  type: "bar",
                  height: _vm.chartOptions.chart.height,
                  options: _vm.chartOptions,
                  series: _vm.series,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }